import React from 'react';
import ChevronDown from '@uber/base-icons/chevron-down';
import type { Theme } from 'baseui';
import { useStyletron } from 'baseui';
const SelectArrowIcon = () => {
  const [css, theme] = useStyletron();
  return <span className={css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  })}>
      <ChevronDown size={theme.sizing.scale500} className={css({
      display: 'block'
    })} />
    </span>;
};
export const getCompactSelectOverrides = (widthToken: keyof Theme['sizing']) => ({
  Root: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      backgroundColor: $theme.colors.backgroundSecondary,
      borderRadius: $theme.borders.radius300,
      width: $theme.sizing[widthToken],
      height: $theme.sizing.scale900,
      display: 'flex',
      alignItems: 'center'
    })
  },
  ControlContainer: {
    style: () => ({
      borderWidth: '0px',
      backgroundColor: 'transparent',
      minHeight: '0px',
      display: 'flex',
      alignItems: 'center'
    })
  },
  ValueContainer: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      ...$theme.typography.LabelSmall,
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingLeft: $theme.sizing.scale300,
      color: $theme.colors.contentTertiary,
      display: 'flex',
      alignItems: 'center'
    })
  },
  IconsContainer: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      paddingLeft: $theme.sizing.scale100,
      paddingRight: $theme.sizing.scale300,
      display: 'flex',
      alignItems: 'center'
    })
  },
  SelectArrow: {
    component: SelectArrowIcon
  },
  DropdownListItem: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      ...$theme.typography.LabelSmall,
      color: $theme.colors.contentTertiary,
      padding: $theme.sizing.scale300,
      borderBottom: `1px solid ${$theme.colors.borderOpaque}`,
      ':last-child': {
        borderBottom: 'none'
      },
      ':hover': {
        backgroundColor: $theme.colors.backgroundTertiary
      }
    })
  },
  Dropdown: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      backgroundColor: $theme.colors.backgroundSecondary,
      borderRadius: $theme.borders.radius300,
      padding: '0px',
      boxShadow: $theme.lighting.shadow600
    })
  },
  Popover: {
    props: {
      overrides: {
        Body: {
          style: ({
            $theme
          }: {
            $theme: Theme;
          }) => ({
            backgroundColor: 'transparent',
            borderRadius: $theme.borders.radius300,
            boxShadow: 'none'
          })
        },
        Inner: {
          style: ({
            $theme
          }: {
            $theme: Theme;
          }) => ({
            backgroundColor: $theme.colors.backgroundSecondary,
            borderRadius: $theme.borders.radius300
          })
        }
      }
    }
  },
  OptionContent: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      ...$theme.typography.LabelSmall,
      color: $theme.colors.contentTertiary
    })
  }
});